<template>
	<v-dialog
		v-model="dialog"
		max-width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				:disabled="!selectedInfos.length"
				color="secondary"
				class="ml-2"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-1">mdi-content-save-all-outline</v-icon>
				バックアップ実施
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">バックアップ実施</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="closeDialog" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<p>バックアップには時間がかかります。<br />連休前などに実行してください。</p>

				<div class="mt-4" v-if="isBackupStarted">
					<v-progress-linear v-model="progress" color="secondary" height="25">
						<template v-slot:default="{ value }">
							<strong class="white--text">{{ Math.ceil(value) }}%</strong>
						</template>
					</v-progress-linear>
				</div>
				<v-form v-model="valid" ref="form">
					<v-select
						label="バックアップ方法"
						class="mt-4"
						:items="backup_methods"
						v-model="backup_method"
						item-text="name"
						item-value="id"
						:rules="[rules.required]"
						outlined
						dense
					/>
				</v-form>
				<v-row no-gutters justify="center" class="mt-4">
					<v-col sm="3" cols="0" />
					<v-col sm="6" cols="12" class="text-center">
						<v-btn @click="createBackup" color="secondary" :disabled="!valid"
							>バックアップ開始</v-btn
						>
					</v-col>
					<v-col sm="3" cols="0">
						<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
					</v-col>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"

export default {
	props: {
		selectedInfos: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			common,
			rules,
			valid: false,
			dialog: false,
			backup_methods: [
				{ id: "zip", name: "圧縮ファイル(zip)でダウンロード" },
				// { id: "server", name: "バックアップサーバーに保存" }, TODO
			],
			backup_method: null,
			progress: 0,
			isBackupStarted: false,
		}
	},
	methods: {
		createBackup() {
			this.isBackupStarted = true
			const headers = authenticate.setHeader()
			const params = {
				backup_method: this.backup_method,
				selected_ids: this.selectedInfos.map((info) => info.id),
			}
			axios
				.post("/erp/v1/backups", params, {
					headers,
					responseType: "blob",
					onUploadProgress: (progressEvent) => {
						this.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100)
					},
				})
				.then((res) => {
					// 成功処理
					console.log(res.data)
					console.log(res.headers)
					const content_disposition = res.headers["content-disposition"]
					const match = content_disposition.match(/filename\*=UTF-8''([^"]+)/)
					const filename = match ? decodeURIComponent(match[1]) : null
					const blob = new Blob([res.data], { type: res.headers["content-type"] })
					const url = URL.createObjectURL(blob)
					const link = document.createElement("a")
					link.href = url
					link.download = filename
					link.click()

					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "バックアップが完了しました。",
					})
					const ids = res.headers["x-directory-names"].split(",")
					this.$emit("update-backup", ids)
					this.closeDialog()
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => (this.isBackupStarted = false))
		},
		closeDialog() {
			this.dialog = false
			this.$refs.form.reset()
		},
	},
}
</script>
